import {
  Kidneys,
  Icd10,
  HealthWorkerForm,
  IDocumentsDenied,
  BlisterPillsRoundX4,
} from 'healthicons-react';

/**
 * healthicons-react components for physician apps. These resolve which SVG
 * glyph to render inside the physician squircle (svgbase.svg background).
 *
 * Color is applied uniformly in AppSquircle (PHYSICIAN_GLYPH_COLOR = #0A5F35)
 * via CSS fill override, so the `color` field here is unused for rendering —
 * kept only as reference / for future per-app differentiation.
 *
 * phys-icd10x uses a Phosphor icon and is handled via the isPhysicianApp path
 * in AppSquircle without needing an entry here.
 */
interface HealthAppIcon {
  component: React.ComponentType<any>;
  color: string;
}

export const HEALTH_APP_ICONS: Record<string, HealthAppIcon> = {
  'phys-crcl':         { component: Kidneys,              color: '#0A5F35' },
  'phys-icd10':        { component: Icd10,                color: '#0A5F35' },
  'phys-em':           { component: HealthWorkerForm,     color: '#0A5F35' },
  'phys-denial':       { component: IDocumentsDenied,     color: '#0A5F35' },
  'phys-interactions': { component: BlisterPillsRoundX4,  color: '#0A5F35' },
};
